import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { RubroService } from "src/app/services/rubro.service";
import { TerritorioService } from "src/app/services/territorio.service";
import { VendedorService } from "src/app/services/vendedor.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";

@Component({
  selector: "app-territorios-anualizado",
  templateUrl: "./territorios-anualizado.component.html",
  styleUrls: ["./territorios-anualizado.component.scss"],
  providers: [SecurityService]
})
export class TerritoriosAnualizadoComponent implements OnInit {
  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null
  optionsYear: any[] = []

  optionsZona: Array<any> = [];
  optionsTerritorio: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private vendedorService: VendedorService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private territorioService: TerritorioService,
  ) {
    this.log = this.clog.log('REP. VTAS. TERRITORIOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadTerritorios()
    this.loadMesesAndAnhos();
    this.createForm()
  }
  loadMesesAndAnhos() {
    this.optionsYear = this.datesService.GetRangeYears()
  }
  private loadTerritorios() {
    this.territorioService.obtenerCombo({
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1
      }
    }, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsTerritorio = registros.map(territorio => ({ value: territorio.codigo, label: territorio.descripcion, ...territorio }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      anno: [(new Date()).getFullYear()],
      listaTerritorio: [[]],
    });
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = []
    this.listaMovimientosAll = []

    const { anno, listaTerritorio } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        listaTerritorio,
        anno
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.listaMovimientos = null
    this.listaMovimientosAll = null
    this.territorioService.obtenerReporteTerritorioAnualizados(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1


      this.showPage(this.paginationContext.CurrentPage)
      this.calculateTotales()
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  calculateTotales() {
    this.resumen_totales = {
      enero: _.sumBy(this.listaMovimientosAll, 'enero'),
      febrero: _.sumBy(this.listaMovimientosAll, 'febrero'),
      marzo: _.sumBy(this.listaMovimientosAll, 'marzo'),
      abrir: _.sumBy(this.listaMovimientosAll, 'abrir'),
      mayo: _.sumBy(this.listaMovimientosAll, 'mayo'),
      junio: _.sumBy(this.listaMovimientosAll, 'junio'),
      julio: _.sumBy(this.listaMovimientosAll, 'julio'),
      agosto: _.sumBy(this.listaMovimientosAll, 'agosto'),
      septiembre: _.sumBy(this.listaMovimientosAll, 'septiembre'),
      octubre: _.sumBy(this.listaMovimientosAll, 'octubre'),
      noviembre: _.sumBy(this.listaMovimientosAll, 'noviembre'),
      diciembre: _.sumBy(this.listaMovimientosAll, 'diciembre'),
      acumulado: _.sumBy(this.listaMovimientosAll, 'acumulado'),
    }
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.territorioService.obtenerReporteTerritorioAnualizadosExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  LimpiarData(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.formHeader.get('anno').setValue([(new Date()).getFullYear()]),
    this.formHeader.get("listaTerritorio").setValue([])
    this.listaMovimientos = null
    this.listaMovimientosAll = null
  }
}
